document.addEventListener('DOMContentLoaded', function () {

  /* ---------- Header: transparente até rolar ---------- */
  var header = document.querySelector('.m-header');
  if (header && header.dataset.transparent === 'true') {
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 40);
    };
    document.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Drawer mobile ---------- */
  var drawer = document.querySelector('[data-drawer]');
  document.querySelectorAll('[data-drawer-open]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (drawer) drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
  });
  document.querySelectorAll('[data-drawer-close]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (drawer) drawer.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  });

  /* ---------- Acordeão do drawer ---------- */
  document.querySelectorAll('[data-accordion-trigger]').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var panel = trigger.nextElementSibling;
      var isOpen = panel.classList.contains('is-open');
      document.querySelectorAll('[data-accordion-panel].is-open').forEach(function (p) {
        p.classList.remove('is-open');
      });
      if (!isOpen) panel.classList.add('is-open');
    });
  });

  /* ---------- Busca ---------- */
  var searchPopup = document.querySelector('[data-search-popup]');
  document.querySelectorAll('[data-search-open]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (searchPopup) {
        searchPopup.classList.add('is-open');
        var input = searchPopup.querySelector('[data-search-input]');
        if (input) setTimeout(function () { input.focus(); }, 100);
      }
    });
  });
  document.querySelectorAll('[data-search-close]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (searchPopup) searchPopup.classList.remove('is-open');
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (searchPopup) searchPopup.classList.remove('is-open');
      if (drawer) drawer.classList.remove('is-open');
    }
  });
});
